export const SELECTED_COMPANY_HEADER_NAME = 'x-selected-company';

export const IMPERSONATED_USER_HEADER_NAME = 'x-impersonated-user';
